import React from 'react';

import type { CodeBlockRedlineNote } from '@aline/common';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  message: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  root: {
    border: `1px solid ${theme.appColors.rule}`,
    borderRadius: 8,
    padding: theme.spacing(1.5),
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
  },
}));

/**
 * Renders a `note` from the AI — a general, user-facing message — as a neutral,
 * non-actionable card inside the redline list. Once inside the editor subagent,
 * edits and errors are its only other outputs, so a note is the one way it can
 * say anything that is neither an edit nor an error. For example, explaining why
 * an edit was NOT made (unsupported change, target not found, no edit needed) —
 * but a note can carry any message the agent needs to surface, so its use is not
 * limited to that case. Nothing is applied to the document.
 */
export const RedlineNoteItem = React.memo(function RedlineNoteItem({
  note,
}: {
  note: CodeBlockRedlineNote;
}): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Note</Typography>
      <Typography className={classes.message}>{note.text}</Typography>
    </div>
  );
});
